import React, { useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import { Logo, GearIcon, SignOutIcon, AwardMinIcon, InvitationIcon, StripeIcon } from "../../assets/imageAssets";
import { User01 } from "@untitledui/icons/User01";
import Button from "../../components/Button";
import { MagicWand02 } from "@untitledui/icons/MagicWand02"; 
import { DownloadCloud02 } from "@untitledui/icons/DownloadCloud02";
import { useSelector, useDispatch } from 'react-redux';
import { setUser } from "../../redux/me.slice";
import { openModals } from "../../redux/modal.slice";
import ModalsEnum from "../../enums/modal.enum";
import { useAmbassadorOnboardingLinkMutation } from "../../api/mutations/ambassadors.mutation";

const Header = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const pathname = location.pathname;
    const user = useSelector((state) => state.me.data);
    const [userDropdownOpen, setUserDropdownOpen] = useState(false);
    const hasSubscription = user?.user_premium_status?.has_premium_access;
    const { mutateAsync: getAmbassadorOnboardingLink } = useAmbassadorOnboardingLinkMutation();

    const handleUserDropdownOpen = () => {
        setUserDropdownOpen(!userDropdownOpen);
    }
    const handleLogout = () => {
        dispatch(setUser(null));
        localStorage.removeItem('assessmentai-token');
    }

    const openUploadAndGenerateModal = () => {
        dispatch(
            openModals({
              modalIds: [ModalsEnum.UPLOAD_AND_GENERATE_MODAL],
            })
        );
    }

    const openInvitationModal = () => {
        dispatch(
            openModals({
                modalIds: [ModalsEnum.INVITATION_MODAL],
                modalData: [
                    {
                        className: 'ambassador-modal',
                    }
                ]
            })
        );
    }

    const getExtensionUrl = () => {
        const userAgent = navigator.userAgent;
        const isEdge = /Edg/i.test(userAgent);
        
        if (isEdge) {
            // Microsoft Edge Add-ons store URL
            return "https://microsoftedge.microsoft.com/addons/detail/campus-ai-canvas-ai-hom/nhafilfhcpaojcmnmcabmpkblpepfhho";
        } else {
            // Chrome Web Store URL (default)
            return "https://chromewebstore.google.com/detail/campus-ai-canvas-ai-homew/gbkgialchigfapopdbliekaekaanhpen?hl=en";
        }
    }

    const handleAmbassadorModal = () => {
        dispatch(
            openModals({
                modalIds: [ModalsEnum.AMBASSADOR_MODAL],
                modalData: [
                    {
                        className: 'ambassador-modal',
                    }
                ]
            })
        );
    }

    const connectStripe = async () => {
        const response = await getAmbassadorOnboardingLink({});

        if (response?.onboarding_url) {
            window.open(response.onboarding_url, '_blank', 'noopener,noreferrer');
        }
    }

    return (
        <header>
            <div className="container">
                <div className="head flex flex-align-center flex-between">
                    <Link to="/" className='logo'>
                        <img src={Logo} alt="Logo" />
                    </Link>
                    {user &&
                        <div className='flex flex-align-center'>
                            <Button
                                text="Become an Ambassador"
                                icon={<img src={AwardMinIcon} alt="Award" />}
                                className='mr-16 ambassador-button'
                                type="outlined"
                                onClick={handleAmbassadorModal}
                            />
                            <Link to={getExtensionUrl()} target="_blank" rel="noopener noreferrer" className='download-button mr-12'>
                                <DownloadCloud02 size={20} className='mr-8' color='#fff' />
                                <span>Download</span>
                            </Link>
                            {pathname !== "/" && hasSubscription &&
                                <Button
                                    text="Upload & Generate"
                                    type="outlined"
                                    className='upload-button mr-16'
                                    icon={<MagicWand02 size={20} className='mr-8' color='#4D4D4D' />}
                                    onClick={openUploadAndGenerateModal}
                                />
                            }
                            <div className="user-box flex flex-align-center" onClick={handleUserDropdownOpen}>
                                <div className="icon">
                                    <User01 size={24} color='#666666' />
                                </div>
                                {pathname === "/" &&
                                    <div className='ml-12'>
                                        <div className="name">{user?.first_name}</div>
                                        <div className="email" title={user?.email}>{user?.email}</div>
                                    </div>
                                }
                                {userDropdownOpen && 
                                    <ul className='user-dropdown'>
                                        <li>
                                            <Link to={'/payment'}>
                                                <img src={GearIcon} alt="Upgrade Plan" className='mr-8' />
                                                Manage Subscription
                                            </Link>
                                        </li>
                                        <li>
                                            <button onClick={openInvitationModal}>
                                                <img src={InvitationIcon} alt="Your Invitation Link" className='mr-8' />
                                                Your Invitation Link
                                            </button>
                                        </li>
                                        <li>
                                            <button onClick={connectStripe}>
                                                <img src={StripeIcon} alt="Your Invitation Link" className='mr-8' />
                                                Connect Stripe for <br /> Ambassador Payments
                                            </button>
                                        </li>
                                        <li>
                                            <button onClick={handleLogout}>
                                                <img src={SignOutIcon} alt="Log out" className='mr-8' />
                                                Log out
                                            </button>
                                        </li>
                                    </ul>
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
        </header>
    );
}

export default Header;